<template>
  <div>
    <search-list
    @searchParams="search"
    :companyList="companyList"
    ></search-list>
    <div class="page-wrapper" style="padding-top: 0">
      <Button type="primary"  v-p="{api:'metaPermission/saveMetaPermission'}" @click.stop="addN++" class="mb16">新增</Button>
      <table-list
        :columns="columns"
        :data="data"
        :current="current"
        :total="total"
        :loading="loading"
        @change-page="changPage"
      >
      </table-list>
    </div>
    <add
      :n="addN"
      @done="getSearchData"
      :companyList="companyList"
    ></add>
  </div>
</template>

<script>
import SearchList from './components/SearchList'
import TableList from 'components/TableList/index'
import Add from './components/Add'
import { allCompany,metaPermissionListByPage ,deleteMetaPermission } from 'api/metadistribution'
import {formatDateTime} from "../../../../utils/format"

export default {
  components:{
    SearchList,
    TableList,
    Add,
  },
  data(){
    return{
      addN:0,
      data: [],
      loading:false,
      total:0,
      current:1,
      page:1,
      limit:10,
      companyList:[],
      columns:[
        {
          title:'编号',
          type: 'index',
          width: 60,
          align: 'center'
        },
        {
          title: ' '
        },
        {
          title: '机构名称',
          align: 'center',
          key: 'orgName',
          width: 120,
        },
        {
          title: ' '
        },
        {
          title: '元数据名称',
          align: 'center',
          key: 'fieldName',
          width: 260,
        },
        {
          title: ' '
        },
        {
          title: '创建人',
          align: 'center',
          key: 'createBy',
          width: 100,
        },
        {
          title: ' '
        },
        {
          title: '创建时间',
          align: 'center',
          key: 'createTime',
          width: 160,
          render: (h, params) => {
            return h('span', {}, this.format(params.row['createTime']))
          }
        },
        {
          title: ' '
        },
        {
          title: '操作',
          align: 'center',
          key: 'action',
          width: 80,
          fixed: 'right',
          render: (h, params) => {
            return h('div', [
              h('a', {
                directives:[
                  {
                    name:'p',
                    value:{
                      api:'metaPermission/deleteMetaPermission'
                    }
                  }
                ],
                style: {
                  marginRight: '5px',
                },
                on: {
                  click: () => {
                    this.$Modal.confirm({
                      title: '删除元数据',
                      content: '<p>确认删除本条元数据？</p>',
                      onOk: () => {
                        let params1 = {
                          orgMetaRelFid:params.row['orgMetaRelFid']
                        }
                        deleteMetaPermission(params1)
                        .then( res => {
                          if(res.code === 0){
                            this.$Message.success('删除成功')
                            this.getSearchData();
                          }
                        })
                        .catch( err => {
                          this.$Message.info('删除失败')
                        })
                        .finally( ()=> {
                          this.isShow = false
                        })
                      }
                    })
                  }
                }
              }, '删除'),
            ])
          }
        },
        {
          title: ' '
        },
      ]
    }
  },
  created(){
    this.getCompany();
  },
  methods:{
    getCompany(){
      allCompany()
      .then( res=> {
        this.companyList = res.data;
      })
    },
    search(data){
      this.searchParams = data
      this.page=1
      this.current=1
      this.getSearchData();
    },
    getSearchData(){
      let params= {
        ...this.searchParams,
        page:this.page,
        limit:this.limit
      }
      metaPermissionListByPage(params)
      .then( res => {
        this.data = res.data.rows
        this.total = res.data.total
      })
    },
    changPage(n){
      this.current = n;
      this.page = n;
      this.getSearchData()
    },
    format(data) {
      if (!data) {
        return ''
      }
      return formatDateTime(data)
    }
  }
}
</script>

<style>

</style>
